import Vue from 'vue'

class CoreInterface {
  cardDragStart(pluginPreview) {
    const message = {
      type: pluginPreview ? "plugin-card-drag-start" : "ext-card-drag-start",
    };
    this._postMessage(message);
  }

  cardDragEnd(position, content, pluginPreview) {
    const message = {
      type: pluginPreview ? "plugin-card-drag-end" : "ext-card-drag-end",
      position: position,
      content: content
    };
    this._postMessage(message);
  }

  sendClickEvent() {
    const event = {
      name: 'click'
    }
    this._postMessage(event)
  }

  _postMessage(message) {
    window.parent.postMessage(JSON.stringify(message), "*");
  }
}

const instance = new CoreInterface()
Vue.prototype.$coreInterface = instance

/*this.$refs.cardRoot.addEventListener('click', (event) => {
      console.log('event.position', {x: event.offsetX, y: event.offsetY})
    })*/
    /*if (this.behavior === "consumer") {
      setTimeout(() => {
        var event = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: 385,
          clientY: 712
        });
        console.log("event", event);
        const s = document.elementFromPoint(385, 712);
        s.dispatchEvent(event);
      }, 2000);
      window.addEventListener("click", (event) => {
        console.log(event.clientX, event.clientY, event.isTrusted);
        if(!event.isTrusted) {
          var d = document.createElement("div");
          d.className = "clickEffect";
          d.style.top = event.clientY + "px";
          d.style.left = event.clientX + "px";
          document.body.appendChild(d);
          d.addEventListener(
            "animationend",
            () => { 
              d.parentElement.removeChild(d);
            }
          );
        }
      });
    }*/
    /*window.addEventListener('*', event => {
      console.log(event)
    })*/